import React from 'react';
import { getDateFormat } from '@airasia-common/libraries/datetime';
import { useWindowSize } from '../../utils';
import Icon from '../Icon';
import TextInputMask from './TextInputMask';

const DateRangeIcon = () => <Icon icon="DateRangeIcon" />;

const getMaskCharByDateFormat = dateFormat =>
  dateFormat
    .split('')
    .find(dateFormatChar => !new RegExp(/[A-Za-z]/, 'g').test(dateFormatChar));

const convertDateFormatToMask = (dateFormat, maskChar) => {
  const dateFormatChars = dateFormat.split(maskChar);
  const result = dateFormatChars.reduce((mask, dateFormatChar, index) => {
    const lastIndex = index === dateFormatChars.length - 1;
    const regex = lastIndex ? /[0-9]/ : /[0-9/]/;
    mask = [...mask, ...dateFormatChar.split('').map(() => regex)];
    if (!lastIndex) {
      mask.push(maskChar);
    }
    return mask;
  }, []);
  return result;
};

export const DateInputMask = props => {
  const { isMobileView } = useWindowSize();

  const dateformatPlaceHolder = getDateFormat().toUpperCase();
  const maskChar = getMaskCharByDateFormat(getDateFormat());

  const handleRenderDateBlock = blockValue => {
    const newValue = blockValue.replace(/[A-Za-z]/g, 0);
    if (newValue === blockValue) {
      return blockValue;
    }
    return newValue >= 10 && blockValue.length === 2
      ? [...newValue].reverse().join('')
      : newValue;
  };

  return (
    <TextInputMask
      maskPlaceholder={dateformatPlaceHolder}
      maskChar={maskChar}
      mask={convertDateFormatToMask(getDateFormat(), maskChar)}
      renderBlock={handleRenderDateBlock}
      customIcon={isMobileView ? DateRangeIcon : null}
      showLabel={true}
      {...props}
    />
  );
};

export default DateInputMask;
